// Copyright (c) 2018, Picsa Advisory Services (Pty) Ltd. All rights reserved.

import React from 'react'

import moment from 'moment'

import { SpanWithData } from '../'

import {
  showAsCurrency,
  getNodeTypeFromBase64Id,
  upperCaseFirstCharacter
} from '../../utils'


export const CreditDetailsRow = ({ loan, onClick }) => {
  let isLoanNode = getNodeTypeFromBase64Id(loan.id) === 'LoanNode'
  return (
    <tr className='clickable' onClick={() => onClick(loan)}>
      <td data-label='Type'>
        {isLoanNode
          ? <SpanWithData forField="LoanLoanType" searchKey={loan.loanType} />
          : <SpanWithData forField="CreditCreditType" searchKey={loan.creditType} />
        }
      </td>
      <td data-label='Status'>
        {isLoanNode
          ? upperCaseFirstCharacter(loan.lmsStatus)
          : upperCaseFirstCharacter(loan.cmsStatus)
        }
      </td>
      <td data-label='Amount'>
        {loan.balance ? showAsCurrency('R', loan.balance) : ''}
      </td>
      <td data-label='Instalment'>
        {loan.instalmentCurrent ? showAsCurrency('R', loan.instalmentCurrent) : ''}
      </td>
      <td data-label='Created at'>
        {loan.createdAt
          ? moment(loan.createdAt).format('lll')
          : '-'
        }
      </td>
    </tr>
  )
}



// WEBPACK FOOTER //
// ./src/components/loanapplication-loans/CreditDetailsRow.js